import { useState } from "react";
import Button from "components/button";
import LoaderButton from "components/button/LoaderButton";
import Modal from "components/modal";
import { useDispatch, useSelector } from "react-redux";
import { deleteOrder } from "store/orderSlice";

const DeleteIOrder = ({ data, refreshList }) => {
  const dispatch = useDispatch();
  const { deleteOrderError, deleteOrderLoading } = useSelector(
    (state) => state.orders
  );

  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleDelete = async () => {
    try {
      await dispatch(deleteOrder(data)).unwrap();
      refreshList();
      closeModal();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  return (
    <>
      {/* Trigger button */}
      <Button variant="red" onClick={openModal}>
        Delete
      </Button>

      {/* Modal */}
      <Modal isOpen={isOpen} onClose={closeModal} className="max-w-lg">
        <h2 className="border-b py-3 pl-2 text-xl font-bold text-navy-700 dark:text-white">
          Delete Order
        </h2>

        <div className="relative w-full rounded-3xl p-4 lg:p-5">
          <p className="mb-6 text-sm text-gray-500 dark:text-gray-400">
            Are you sure you want to delete this order?
          </p>

          <div className="flex flex-col">
            {deleteOrderError && (
              <div className="mt-2 grid grid-cols-1 gap-5">
                <p className="text-sm text-red-500">{deleteOrderError}</p>
              </div>
            )}

            <div className="mt-6 flex items-center justify-end gap-3">
              <Button type="button" variant="outline" onClick={closeModal}>
                Cancel
              </Button>

              <LoaderButton
                type="button"
                isLoading={deleteOrderLoading}
                onClick={handleDelete}
              >
                Delete Order
              </LoaderButton>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DeleteIOrder;
